import { Link } from "react-router-dom";
import { IMG, CONTACT } from "@/lib/site";
import { useT } from "@/lib/i18n";

const HomeFinalCta = () => {
  const t = useT();
  return (
    <section className="relative overflow-hidden" data-testid="final-cta-section">
      <div className="grid lg:grid-cols-2">
        <div className="aspect-[4/5] lg:aspect-auto">
          <img
            src={IMG.handsHolding}
            alt="Acompañamiento cuerpo-mente · Método TAO"
            className="w-full h-full object-cover"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="bg-sand/50 grain flex items-center px-6 md:px-16 lg:px-20 py-20 lg:py-32">
          <div className="max-w-md">
            <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-6">{t("home.finalCta.eyebrow")}</p>
            <h2 className="font-serif text-4xl md:text-6xl text-charcoal leading-[1.02]">
              {t("home.finalCta.title1")} <span className="italic">{t("home.finalCta.title2")}</span>.
            </h2>
            <p className="mt-6 text-charcoal/70 leading-relaxed text-lg">
              {t("home.finalCta.body")}
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link
                to="/contacto"
                data-testid="final-cta-reserva"
                className="inline-flex items-center justify-center gap-2 bg-charcoal text-ivory rounded-full px-7 py-4 text-sm font-medium hover:bg-terracotta transition-all"
              >
                {t("home.finalCta.book")}
              </Link>
              <a
                href={CONTACT.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-cta-whatsapp"
                className="inline-flex items-center justify-center gap-2 border border-charcoal/30 text-charcoal rounded-full px-7 py-4 text-sm font-medium hover:bg-charcoal hover:text-ivory transition-all"
              >
                {t("home.finalCta.whatsapp")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFinalCta;
